/**
 * Service Worker registration for Quran audio offline support.
 * Called once on app start from App.js.
 */

const SW_URL = '/quran-sw.js';

export const registerQuranSW = async () => {
  if (!('serviceWorker' in navigator)) return null;

  try {
    const registration = await navigator.serviceWorker.register(SW_URL, { scope: '/' });
    console.log('[QuranSW] Registered:', registration.scope);
    return registration;
  } catch (err) {
    console.warn('[QuranSW] Registration failed:', err);
    return null;
  }
};

/**
 * Pre-cache audio URLs for a surah.
 * Handles first-visit (controller null) by awaiting SW ready.
 */
export const precacheSurahAudio = async (audioUrls) => {
  if (!('serviceWorker' in navigator)) return;
  try {
    const sw = navigator.serviceWorker.controller
      ?? (await navigator.serviceWorker.ready).active;
    if (sw) sw.postMessage({ type: 'PRECACHE_AUDIO', urls: audioUrls });
  } catch { /* non-fatal */ }
};

/**
 * Get cache statistics from SW.
 * Returns a Promise<{audioCount: number}>
 */
export const getCacheStats = () =>
  new Promise((resolve) => {
    if (!navigator.serviceWorker?.controller) { resolve({ audioCount: 0 }); return; }
    const handler = (event) => {
      if (event.data?.type === 'CACHE_STATS') {
        navigator.serviceWorker.removeEventListener('message', handler);
        resolve(event.data);
      }
    };
    navigator.serviceWorker.addEventListener('message', handler);
    navigator.serviceWorker.controller.postMessage({ type: 'GET_CACHE_STATS' });
    setTimeout(() => { navigator.serviceWorker.removeEventListener('message', handler); resolve({ audioCount: 0 }); }, 3000);
  });
